<template>
  <div v-if="isShow">
    <summary-detail :name="customerName" type="客户" :key-customer-id="keyCustomerId" :year="year" :is-scope="false">
      <div>
        <!--      <span v-if="keyCustomerId" style="float: right"><el-tag type="warning" effect="plain" size="small">重点客户</el-tag></span>-->
        <el-row style="text-align: left;margin: 5px">
          下单频率：<a @click="getMonthlySum" style="color: #E03F3D;font-size: 1.25em;cursor: pointer;">{{
            gFunc.numberFormat(monthlyData.count)
          }}</a> 单/月
          &emsp;
          (1~{{ monthlyData.month }}月)
          <br/>
          月度价值：<span style="color: #E03F3D;font-size: 1.25em">{{ gFunc.numberFormat(monthlyData.money) }}</span> 元/月
          &emsp;(1~{{ monthlyData.month }}月)
          &emsp; &emsp;
          <span style="color: #cb5c13">备注：只算到前一个月截止，因为当月没过完，数据来摊均值不具参考意义。</span>
        </el-row>
        <!--      平台单量-->
        <platform-count :year="year" :key-customer-id="keyCustomerId" :customer-id="customerId"
                        :organization-id="organization_id"/>
        <br/>
        <platform-money :year="year" :key-customer-id="keyCustomerId" :customer-id="customerId"
                        :organization-id="organization_id"/>
        <br/>
        <d-brand-count :year="year" :key-customer-id="keyCustomerId" :customer-id="customerId"
                       :organization-id="organization_id"/>
        <br/>
        <d-brand-money :year="year" :key-customer-id="keyCustomerId" :customer-id="customerId"
                       :organization-id="organization_id"/>
        <br/>
        <customer-per-price :year="year" :key-customer-id="keyCustomerId" :customer-id="customerId"
                            :organization-id="organization_id"/>
        <br/>
        <artist :year="year" :key-customer-id="keyCustomerId" :customer-id="customerId"
                :organization-id="organization_id"/>
        <br/>
      </div>
    </summary-detail>
  </div>

</template>

<script>
import platformCount from "@/components/summary/detail/platformCount";
import platformMoney from "@/components/summary/detail/platformMoney";
import customerPerPrice from "@/components/summary/detail/customerPerPrice";
import artist from "@/components/summary/detail/artist";
import {customerDetailMonthlySum} from "@/api/dashboard";
import SummaryDetail from "@/views/dashboard/components/Detail.vue";
import DBrandCount from "@/components/summary/detail/brandCount.vue";
import DBrandMoney from "@/components/summary/detail/brandMoney.vue";

export default {
  name: "SummaryCustomerDetail",
  components: {DBrandMoney, DBrandCount, SummaryDetail, platformCount, platformMoney, customerPerPrice, artist},
  data() {
    return {
      customerName: this.$route.query.customerName,
      customerId: this.$route.query.customerId,
      keyCustomerId: this.$route.query.keyCustomerId,
      year: this.$route.query.year,
      data: [],
      organization_id: this.$route.query.organization_id || 'ALL',
      monthlyData: {count: 0, money: 0, month: 12},
    }
  },
  computed: {
    isShow() {
      return this.customerId || this.keyCustomerId
    }
  },

  created() {
    if (this.isShow) {
      this.getMonthlySum()
    } else {
      this.showModal({
        h: this,
        text: `非法链接,返回上级`,
        confirmText: "",
        cancelText: "",
        confirm: async () => {
          this.$router.go(-1)
        }
      });
    }
  },
  methods: {
    getMonthlySum() {
      this.dataMoney = [];
      customerDetailMonthlySum({
        year: this.year,
        customer_id: this.customerId,
        key_customer_id: this.keyCustomerId,
        organization_id: this.organization_id,
      }).then(res => {
        this.monthlyData = res.model
      })
    },
  }
}
</script>

<style>

</style>
